export const MENU_TOGGLE = 'MENU_TOGGLE';
export const HEADER_MENU_TOGGLE = 'HEADER_MENU_TOGGLE';
export const SET_PAGE_LOADER = 'SET_PAGE_LOADER';
export const REMOVE_PAGE_LOADER = 'REMOVE_PAGE_LOADER';
export const SET_AUTH_LOADER = 'SET_AUTH_LOADER';
export const REMOVE_AUTH_LOADER = 'REMOVE_AUTH_LOADER';

export const mainLayoutMenuToggleAction = (state) => ({
  type: MENU_TOGGLE,
  state: !state,
});

export const toggleHeaderMenu = (payload) => ({
  type: HEADER_MENU_TOGGLE,
  payload,
});

export const setAuthLoadingAction = () => ({
  type: SET_AUTH_LOADER,
});

export const removeAuthLoadingAction = () => ({
  type: REMOVE_AUTH_LOADER,
});

export const setPageLoadingAction = () => ({
  type: SET_PAGE_LOADER,
});

export const removePageLoadingAction = () => ({
  type: REMOVE_PAGE_LOADER,
});
